module.exports = __webpack_public_path__ + "img/534.26909b4b.png";